import BreatherHeading from '@/components/_organisms/BreatherHeading';
import FrontPinkButton from '@/components/buttons/primary/FrontPinkButton';
import Link from '@/components/Link';
import { ModuleBreatherHeadingFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { FC, ReactNode } from 'react';

interface BreatherHeadingModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleBreatherHeadingFragment>;
  ctaOverride?: (originalNode: ReactNode) => ReactNode;
}

const BreatherHeadingModule: FC<BreatherHeadingModuleProps> = ({ props, className, ctaOverride }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const singleCta = getSingleLink(props.cta);

  const cta = singleCta ? (
    <Link href={singleCta.url}>
      <FrontPinkButton>{singleCta.text}</FrontPinkButton>
    </Link>
  ) : undefined;

  return <BreatherHeading text={props.heading ?? ''} cta={ctaOverride ? ctaOverride(cta) : cta} />;
};

export default BreatherHeadingModule;
